// Small, always-needed bits of this page (path, title, dates), kept apart from the
// page text so the main app bundle does not have to carry the whole page.
export const WMHD_PATH = '/world-mental-health-day';
export const WMHD_URL = `https://www.zuzu.club${WMHD_PATH}`;

// 10 October, every year. Used for the countdown and the "it's today" state.
export const WMHD_YEAR = 2026;
export const WMHD_THEME = 'Lived Experiences Heard: Real Voices, Real Change';

export const WMHD_META = {
  // Title under ~60 characters and description under ~160, so search results show them whole.
  // No "| Zuzu Club": Google already shows the site name above the link.
  title: 'World Mental Health Day 2026: Theme, Facts & Resources',
  // Social cards and the article headline: the plain name of the page.
  shareTitle: 'World Mental Health Day 2026 Resource by Zuzu Club',
  description: 'World Mental Health Day 2026 resources: the theme, WHO facts, school and workplace ideas, messages, movies, books, organisations and where to find support.',
  keywords: 'world mental health day, world mental health day 2026, world mental health day 2026 theme, world mental health day quotes, world mental health day messages, world mental health day ideas, world mental health day activities for students, world mental health day at work, lived experiences heard, 10 october, mental health awareness day, mental health statistics 2026, what to do on world mental health day, world mental health day activities, mental health movies, books about mental health, songs about mental health, green ribbon, talk to someone anonymously, free peer support',
  image: 'https://www.zuzu.club/og/zuzu-club-world-mental-health-day.jpg?v=10',
  imageWidth: 1200,
  imageHeight: 630,
  alt: 'World Mental Health Day, Saturday 10 October 2026. Real voices, heard. 2026 theme: Lived Experiences Heard: Real Voices, Real Change. Zuzu Club.',
  published: '2026-10-07',
  modified: '2026-10-12',
  updatedLabel: 'Updated 12 October 2026',
};

// The countdown target: 10 October, local time for the visitor.
export const wmhdWindow = (now = new Date()) => {
  const start = new Date(WMHD_YEAR, 9, 10), end = new Date(WMHD_YEAR, 9, 11);
  return { start, end, live: now >= start && now < end, past: now >= end };
};

// Gentle pointers to this page from elsewhere on Zuzu (Sky, Let Go, after a chat,
// the feelings page...). Only in October of the year above.
export const isWmhdSeason = (now = new Date()) => now.getFullYear() === WMHD_YEAR && now.getMonth() === 9;
export const wmhdNudgeLine = (now = new Date()) => {
  const { live, past } = wmhdWindow(now);
  return live ? 'It’s World Mental Health Day 🌻' : past ? '🌻 World Mental Health Day' : '🌻 World Mental Health Day, 10 Oct';
};
